import React, { useState } from "react";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
  Box
} from "@mui/material";
import { 
  Search as SearchIcon, 
  
  Download as DownloadIcon 
} from "@mui/icons-material";
import Layout from "../components/layout/Calayout";

const FileTrackingPage = () => {
  const [files, ] = useState([
    {
      id: "F001",
      clientName: "Acme Corporation",
      fileType: "Income Tax Return",
      status: "In Progress",
      assignedTo: "John Doe",
      lastUpdated: "2024-06-15",
      priority: "High",
    },
    {
      id: "F002",
      clientName: "Global Enterprises",
      fileType: "GST Audit",
      status: "Pending Review",
      assignedTo: "Jane Smith",
      lastUpdated: "2024-06-10",
      priority: "Medium",
    },
    {
      id: "F003",
      clientName: "Small Business Co.",
      fileType: "Financial Statement",
      status: "Completed",
      assignedTo: "Mike Johnson",
      lastUpdated: "2024-06-05",
      priority: "Low",
    },
  ]);

  const [filter, setFilter] = useState({
    status: "",
    priority: "",
    searchTerm: "",
  });

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return { backgroundColor: "#e6f2e6", color: "#2e7d32" };
      case "In Progress":
        return { backgroundColor: "#fff3e0", color: "#ed6c02" };
      case "Pending Review":
        return { backgroundColor: "#e3f2fd", color: "#1976d2" };
      default:
        return { backgroundColor: "#f5f5f5", color: "#616161" };
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
        return { backgroundColor: "#ffebee", color: "#d32f2f" };
      case "Medium":
        return { backgroundColor: "#fff3e0", color: "#ed6c02" };
      case "Low":
        return { backgroundColor: "#e8f5e9", color: "#2e7d32" };
      default:
        return { backgroundColor: "#f5f5f5", color: "#616161" };
    }
  };

  const filteredFiles = files.filter(
    (file) =>
      (!filter.status || file.status === filter.status) &&
      (!filter.priority || file.priority === filter.priority) &&
      (!filter.searchTerm ||
        file.clientName
          .toLowerCase()
          .includes(filter.searchTerm.toLowerCase()) ||
        file.fileType.toLowerCase().includes(filter.searchTerm.toLowerCase()))
  );

  return (
    <Layout>
      <Card sx={{ width: '100%' }}>
        <CardHeader
          title={
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">File Tracking Dashboard</Typography>
              <Button 
                variant="outlined" 
                size="small" 
                startIcon={<DownloadIcon />}
              >
                Export
              </Button>
            </Box>
          }
        />
        <CardContent>
          <Box display="flex" gap={2} marginBottom={2}>
            <TextField
              placeholder="Search files..."
              variant="outlined"
              fullWidth
              size="small"
              InputProps={{
                startAdornment: <SearchIcon />
              }}
              value={filter.searchTerm}
              onChange={(e) =>
                setFilter((prev) => ({
                  ...prev,
                  searchTerm: e.target.value,
                }))
              }
            />
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={filter.status}
                label="Status"
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }))
                }
              >
                <MenuItem value="">All Statuses</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Pending Review">Pending Review</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel>Priority</InputLabel>
              <Select
                value={filter.priority}
                label="Priority"
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    priority: e.target.value,
                  }))
                }
              >
                <MenuItem value="">All Priorities</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>File ID</TableCell>
                  <TableCell>Client Name</TableCell>
                  <TableCell>File Type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Assigned To</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Priority</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredFiles.map((file) => (
                  <TableRow key={file.id}>
                    <TableCell>{file.id}</TableCell>
                    <TableCell>{file.clientName}</TableCell>
                    <TableCell>{file.fileType}</TableCell>
                    <TableCell>
                      <Chip 
                        label={file.status} 
                        size="small" 
                        sx={getStatusColor(file.status)} 
                      />
                    </TableCell>
                    <TableCell>{file.assignedTo}</TableCell>
                    <TableCell>{file.lastUpdated}</TableCell>
                    <TableCell>
                      <Chip 
                        label={file.priority} 
                        size="small" 
                        sx={getPriorityColor(file.priority)} 
                      />
                    </TableCell>
                    <TableCell>
                      <Button variant="outlined" size="small">
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {filteredFiles.length === 0 && (
            <Typography 
              variant="body2" 
              color="text.secondary" 
              align="center" 
              padding={2}
            >
              No files found matching the current filters.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Layout>
  );
};

export default FileTrackingPage;
